import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { IntlShape } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { IssueLayoutOwner, ExtraDefinerId } from '../../types/issue/issue-layout-owner.tsx';
import { UpdatedEmptyImg } from './assets/updated-empty-state.tsx';

type EmptyStateMessageProps = {
	readonly message: string;
};

export const EmptyStateMessage = ({ message }: EmptyStateMessageProps) => (
	<Wrapper data-testid="project-settings-apps-issue-type-page-product-features.common.ui.empty-state.empty-state-message">
		<ImageContainer>
			<UpdatedEmptyImg />
		</ImageContainer>

		<Text>{message}</Text>
	</Wrapper>
);

type Props = {
	readonly layoutOwners: IssueLayoutOwner[];
	readonly extraDefinerId: ExtraDefinerId | null;
	readonly issueTypeName: string;
	emptyStateText: MessageDescriptor;
	intl: IntlShape;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ emptyStateText, intl, issueTypeName }: Props) => (
	<EmptyStateMessage
		message={intl.formatMessage(emptyStateText, {
			issueTypeName,
		})}
	/>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	maxWidth: '500px',
	margin: '0 auto',
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
	textAlign: 'center',
	height: '100%',
	justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Text = styled.p({
	paddingTop: token('space.050'),

	color: token('color.text'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageContainer = styled.div({
	width: '260px',
});
